import { Converter } from '../types/converter';

export const caseConverter: Converter = {
  id: 'case',
  name: 'Case Converter',
  icon: 'Type',
  categories: ['other'],
  units: [
    { name: 'Lowercase', symbol: 'lower', factor: 1 },
    { name: 'Uppercase', symbol: 'UPPER', factor: 1 },
    { name: 'Title Case', symbol: 'Title', factor: 1 },
    { name: 'Sentence case', symbol: 'Sentence', factor: 1 },
    { name: 'camelCase', symbol: 'camel', factor: 1 },
    { name: 'PascalCase', symbol: 'Pascal', factor: 1 },
    { name: 'snake_case', symbol: 'snake', factor: 1 },
    { name: 'kebab-case', symbol: 'kebab', factor: 1 },
    { name: 'CONSTANT_CASE', symbol: 'CONSTANT', factor: 1 }
  ]
};
